export default (theme) => ({
  textarea: {
    marginTop: 10,
    position: 'relative',
    '& .MuiFormHelperText-contained': {
      width: '70%',
    },
  },
  symbolsCount: {
    position: 'absolute',
    top: '100%',
    right: 10,
    color: theme.palette.font.main,
  },
  symbolsCountWithHelper: {
    top: 'initial',
    bottom: 0,
  },
});
